import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Collapse, List, Typography } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "../icons/chevron-right";
import { ChevronDown as ChevronDownIcon } from "../icons/chevron-down";
import { ExternalLink as ExternalLinkIcon } from "../icons/external-link";

export const DashboardSidebarItem = (props) => {
  const {
    active,
    external,
    href,
    icon: Icon,
    items,
    onOpen,
    open = false,
    pinned = false,
    title,
    location
  } = props;
  const { t } = useTranslation();

  // Branch
  if (items) {
    const isChildActive = items.some((item) => location.pathname === item.href);

    return (
      <List disablePadding sx={{ width: "100%" }}>
        <li>
          <Button
            endIcon={
              open ? (
                <ChevronDownIcon fontSize="small" />
              ) : (
                <ChevronRightIcon fontSize="small" />
              )
            }
            fullWidth
            onClick={onOpen}
            startIcon={<Icon sx={{ color: isChildActive ? "primary.main" : "#475569" }} />}

            sx={{
              justifyContent: "flex-start",
              lineHeight: 0,
              minWidth: "fit-content",
              px: 1.25,
              py: 1.25,
              backgroundColor: isChildActive ? "rgba(5, 150, 105, 0.04)" : "transparent",
              color: isChildActive ? "primary.main" : "#475569",
              fontWeight: isChildActive ? 600 : 400,
              "& .MuiButton-startIcon": {
                margin: 0,
              },
              "& .MuiButton-endIcon": {
                color: isChildActive ? "primary.main" : "action.disabled",
                display: pinned ? "flex" : "none",
                marginLeft: "auto",
              },
              "&:hover": {
                backgroundColor: isChildActive ? "rgba(5, 150, 105, 0.08)" : "rgba(0,0,0,0.04)",
              }
            }}
            variant="text"
          >
            <Typography
              sx={{
                display: pinned ? "flex" : "none",
                ml: 1.25,
                fontSize: '14px'
              }}
              variant="inherit"
            >
              {t(title)}
            </Typography>
          </Button>
        </li>
        <Collapse in={open} unmountOnExit>
          <List disablePadding sx={{ width: "100%" }}>
            {items.map((item) => {
              const SubIcon = item.icon;
              const isSubActive = location.pathname === item.href;

              return (
                <li key={item.href}>
                  <Button
                    component={RouterLink}
                    fullWidth
                    startIcon={
                      <SubIcon sx={{ fontSize: 18, color: isSubActive ? "primary.main" : "#475569" }} />
                    }
                    sx={{
                      fontWeight: isSubActive ? 600 : 400,
                      justifyContent: "flex-start",
                      pl: 5,
                      whiteSpace: "nowrap",
                      fontSize: "14px",
                      color: isSubActive ? "primary.main" : "#475569",
                      backgroundColor: isSubActive ? "rgba(5, 150, 105, 0.08)" : "transparent",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: isSubActive ? "rgba(5, 150, 105, 0.12)" : "rgba(0,0,0,0.04)",
                      },
                    }}
                    to={item.href}
                    variant="text"
                  >
                    {t(item.title)}
                  </Button>
                </li>
              );
            })}
          </List>
        </Collapse>
      </List>
    );
  }


  // Leaf
  return (
    <li>
      <Button
        component={RouterLink}
        fullWidth
        startIcon={<Icon sx={{ color: active ? "primary.main" : "#475569" }} />}
        to={href}
        sx={{
          justifyContent: "flex-start",
          lineHeight: 0,
          minWidth: "fit-content",
          px: 1.25,
          py: 1.25,
          color: active ? "primary.main" : "#475569",
          backgroundColor: active ? "rgba(5, 150, 105, 0.08)" : "transparent",
          fontWeight: active ? 600 : 400,
          textTransform: "none",
          "& .MuiButton-startIcon": { margin: 0 },
          "& .MuiButton-endIcon": {
            color: active ? "primary.main" : "#475569",
            display: pinned ? "flex" : "none",
            marginLeft: "auto",
          },
          "&:hover": {
            backgroundColor: active ? "rgba(5, 150, 105, 0.12)" : "rgba(0,0,0,0.04)",
          },
        }}
        variant="text"
      >
        <Typography
          sx={{
            display: pinned ? "flex" : "none",
            ml: 1.25,
            fontSize: "14px",
          }}
          variant="inherit"
        >
          {t(title)}
        </Typography>
      </Button>
    </li>
  );

};

DashboardSidebarItem.propTypes = {
  active: PropTypes.bool,
  activeHref: PropTypes.string,
  external: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  items: PropTypes.array,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
  pinned: PropTypes.bool,
  title: PropTypes.string,
};
